// userData.js
export const userData = {
  users: [
    {
      email: 'rfern@stanford.edu',
      name: 'Rachel Fernandez',
    },
    {
      email: 'hannahsg@stanford.edu',
      name: 'Hannah Gao',
    },
    {
      email: 'thijs@stanford.edu',
      name: 'Thijs Simonian',
    },
    {
      email: 'nayala17@stanford.edu',
      name: 'Nathalie Ayala',
    },
    {
      email: 'hshu100@stanford.edu',
      name: 'Hannah Shu',
    },
    {
      email: 'cduong03@stanford.edu',
      name: 'Christina Duong',
    },
    {
      email: 'emlo@stanford.edu',
      name: 'Emma López',
    },
    {
      email: 'trub@stanford.edu',
      name: 'Tyler Rubenstein',
    },
    {
      email: 'achinnak@stanford.edu',
      name: 'Anamika Chinnakonda',
    },
    {
      email: 'maxspiv@stanford.edu',
      name: 'Maxwell Spivakovsky',
    },
    {
      email: 'abzhong@stanford.edu',
      name: 'Abraham Zhong',
    },
    {
      email: 'sahanam7@stanford.edu',
      name: 'Sahana Mantha',
    },
    {
      email: 'erinshen@stanford.edu',
      name: 'Erin Shen',
    },
    {
      email: 'danisun@stanford.edu',
      name: 'Danica Sun',
    },
    {
      email: 'mattyu@stanford.edu',
      name: 'Matthew Yu',
    },
    {
      email: 'glwang@stanford.edu',
      name: 'Grace Wang',
    },
    {
      email: 'dcureton@stanford.edu',
      name: 'Dean Cureton',
    },
    {
      email: 'toryn@stanford.edu',
      name: 'Toryn Thompson',
    },
    {
      email: 'mjyao@stanford.edu',
      name: 'Jerry Yao',
    },
    {
      email: 'jagadeep@stanford.edu',
      name: 'Jag Maddipatla',
    },
    {
      email: 'yumich@stanford.edu',
      name: 'Michael Yu',
    },
    {
      email: 'olliesin@stanford.edu',
      name: 'Oliver Sin',
    },
    {
      email: 'shrishp@stanford.edu',
      name: 'Shrish Premkrishna',
    },
    {
      email: 'txg@stanford.edu',
      name: 'Thryambak Ganapathy',
    },
    {
      email: 'alainaz@stanford.edu',
      name: 'Alaina Zhang',
    },
    {
      email: 'mlho@stanford.edu',
      name: 'Madison Ho',
    },
    {
      email: 'ansono@stanford.edu',
      name: 'Anson Omar',
    },
  ],
};

export default userData;
